import { memo, useEffect } from "react";
import { SettingInfoCardProps } from "./types";

import { getLanguageCurrentLocal, useTranslate } from "helpers";

import {
  fetchLanguages,
  getLanguages,
} from "services/api/languages/redux";
import { useDispatch, useSelector } from "react-redux";
import { Language } from "services/api/languages/types";

/*
  Blok "Paketi" je uklonjen: zvao je rute /v1/subscriptions koje na poslužitelju ne postoje, a
  dohvati su ionako bili isključeni. Paket i potrošnja tvrtke sada stoje u gornjoj traci.
*/
const SettingInfoCard: React.FC<SettingInfoCardProps> = () => {

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const languages = useSelector(getLanguages);

  useEffect(() => {
    dispatch(fetchLanguages() as any);
  }, [dispatch]);

  const currentLanguage = getLanguageCurrentLocal();

  return (
    <div className="rounded-sm">
      <div className="divide-y divide-slate-200 ">
        <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
          <div className="flex flex-col flex-1 max-w-[300px]">
            <div>
              <p className="text-base font-bold text-slate-600  py-3  ">
                {t("admin.settinginfocard.detail.languages.title")}
              </p>
              <p className="text-sm">
                {t("admin.settinginfocard.detail.languages.description")}
              </p>
            </div>
          </div>
          <div className="flex flex-1  px-3 my-3">
            <div className="rounded-sm bg-white border ">
              <div className="divide-y divide-slate-200 ">
                <div className=" min-h-[56px] min-w-[300px] divide-y">
                  {languages &&
                    languages?.items.map(
                      (language: Language, index: number) => {
                        return (
                          <div
                            className="flex items-center gap-3 px-3 py-2"
                            key={index}
                          >
                            <div className="">
                              <img
                                src={`/media/icons/flags/${language.id}.png`}
                                alt=""
                              />
                            </div>
                            <div className="flex justify-between w-full">
                              <div>{language.name}</div>
                              <div className="">
                                {language.id === currentLanguage && (
                                  <span className="text-xs font-semibold uppercase rounded-lg bg-yellow-300 border border-yellow-400 px-2 py-0.5  text-yellow-800">
                                    Zadani
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SettingInfoCard);
